export const getNumber = (value: string | number | undefined): number => {
  if (value === undefined) {
    return 0
  }

  if (typeof value === 'string') {
    return Number(value)
  }

  return value
}
